export default "__VITE_ASSET__DSDCPNlt__"